import { getFileExtension } from '../../utils/pathUtils';

export { getFileExtension } from '../../utils/pathUtils';

export const RENDERABLE_DOCUMENT_FORMATS = [
  '.pdf',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.key',
  '.pages',
  '.rtf',
  '.odt',
  '.odp',
  '.txt',
]; // word // powerpoint // keynote // mac pages // open document text // Open document presentation

export const RENDERABLE_IMAGE_FORMATS = [
  '.png',
  '.svg',
  '.jpeg',
  '.jpg',
  '.gif',
  '.heic',
];

export const RENDERABLE_VIDEO_FORMATS = ['.mp4', '.mov'];
export const RENDERABLE_AUDIO_FORMATS = ['.mp3', '.wav', '.m4a'];

export const getFileLink = attachment =>
  attachment.fileId
    ? `${window.AssignmentAppConfig.FILE_SERVICE_CDN}/files/${
        attachment.fileId
      }`
    : `${window.AssignmentAppConfig.CDN_URL}/${attachment.path}`;

export const getAttachmentRenderableFileType = attachment => {
  const extension = getFileExtension(attachment.fileName);
  if (RENDERABLE_DOCUMENT_FORMATS.includes(extension)) return 'document';
  if (RENDERABLE_IMAGE_FORMATS.includes(extension)) return 'image';
  if (RENDERABLE_VIDEO_FORMATS.includes(extension)) return 'video';
  if (RENDERABLE_AUDIO_FORMATS.includes(extension)) return 'audio';

  return '';
};

export const getConvertedFileExtension = attachment => {
  switch (getAttachmentRenderableFileType(attachment)) {
    case 'document':
      return 'pdf';
    case 'image':
      return 'jpg';
    case 'audio':
      return 'mp3';
    case 'video':
      return 'm3u8';
    default:
      console.error('Trying to get extension of unconvertable filetype');
      return '';
  }
};

// TODO: Remove content-disposition if else once we have nonprd CDN
export const getDownloadableFileLink = (link, fileName, fileNameSuffix = '') =>
  `${link}?response-content-disposition=attachment;filename=${encodeURIComponent(
    encodeURIComponent(fileName.split('.')[0]),
  )}${fileNameSuffix}${getFileExtension(fileName)}`;

export const getPreviewFileURL = attachment => {
  const fileType = getAttachmentRenderableFileType(attachment);
  const convertedExtension = getConvertedFileExtension(attachment);
  const originalExtension = getFileExtension(attachment.fileName);

  if (attachment.fileId)
    return `${getFileLink(attachment)}${
      fileType === 'document' && originalExtension !== '.pdf' ? '/preview' : ''
    }`;

  const file = `${getFileLink(attachment).replace(
    '/submissions/',
    '/previews/submissions/',
  )}`;
  return `${file.substr(0, file.lastIndexOf('.'))}.${convertedExtension}`;
};

export const DOCUMENT_FORMATS = [
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.txt',
  '.odt',
  '.odp',
  '.ods',
  '.pages',
  '.key',
  '.numbers',
  '.pdf',
];

export const getAttachmentGeneralFileType = attachment => {
  const extension = getFileExtension(attachment.fileName);
  if (DOCUMENT_FORMATS.includes(extension)) return 'document';
  if (RENDERABLE_IMAGE_FORMATS.includes(extension)) return 'image';
  if (RENDERABLE_VIDEO_FORMATS.includes(extension)) return 'video';
  if (RENDERABLE_AUDIO_FORMATS.includes(extension)) return 'audio';

  return '';
};

export const shouldCheckForFileExistance = attachment =>
  getAttachmentRenderableFileType(attachment) === 'document'
    ? true
    : !attachment.fileId;
